import React, { useEffect, useState, createRef } from 'react';
import { Button, Card, Col, Container, Modal, Row, Accordion } from 'react-bootstrap';
import { toast, Toaster } from "react-hot-toast";
import { axiosOpen } from "../../api/axios";
import './ProposalList.scss';
// import Pdf from "react-to-pdf";
import { FaFilePdf } from "react-icons/fa"; 
import { PDFDownloadLink } from '@react-pdf/renderer';
import DocumentFormat from '../../component/PDF/pdfFormat';


const ProposalList = () => {

  const userID = localStorage.userID && localStorage.getItem('userID');
  const [loader, setLoader] = useState(true);
  const [proposalList, setProposalList] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const handleModalClose = () => setShowModal(false);
  const handleModalOpen = () => setShowModal(true);


  const fetchProposalDetails = async () => {
    try {
      const { data } = await axiosOpen.get(`/api/bd/getUserProposals/${userID}`);
      setProposalList(data?.data);
      console.log(data?.data);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };


  useEffect(() => {
    fetchProposalDetails();
  }, []);

  const [selectedProposal, setSelectedProposal] = useState({});

  const handleProposalModal = (proposal) => {
    handleModalOpen();
    const obj = JSON.parse(JSON.stringify(proposal));
    obj.proposal = obj.proposal ? obj.proposal.trim().toString().replace(/\n\n/gm, "<br/><br/>").replace(/\n/g, "<br/><br/>") : "---";
    setSelectedProposal(obj);
    console.clear()
    console.log('proposal : ', proposal)
  }
  const handleProposalDelete = async (id) => {
    try {
      setLoader(true);
      console.log(id);
      const { data, status } = await axiosOpen.post(`/api/bd/deleteUserProposal`, {
        proposalId: id,
        userId: userID
      });
      if (status === 200) {
        fetchProposalDetails();
        toast.success('Proposal deleted successfully');
      } else {
        toast.error('Something went wrong');
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }

  }

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <Container>
        <Row>
          <div className="section-title text-center pb-4 mt-3">
            <h2>Proposal List</h2>
            <p>{proposalList.length > 0 ? "Your Saved Proposals" : "You have not saved any proposals yet"}</p>
          </div>
        </Row>
        {
          proposalList.length > 0 && proposalList.map((proposal, index) => (
            <>
              <Row className="justify-content-center align-items-center">
                <Col md={10} className="mb-3" key={proposal._id} >
                  <Card>
                    <Card.Body>
                      <Card.Title>{proposal.jobTitle}</Card.Title>
                      <Card.Subtitle className="mb-2 mt-2 text-muted">Tech stack: {proposal.techstack}</Card.Subtitle>
                      <Card.Text>
                        {proposal.jobDescription.slice(0, 100) + '...'}
                      </Card.Text>
                      <Button variant="primary" onClick={() => handleProposalModal(proposal)}>
                        View Proposal
                      </Button>
                      {/* <Pdf targetRef={ref} filename="Proposal.pdf">
                        {({ toPdf }) => <Button variant="success" className="ms-4" onClick={toPdf}><FaFilePdf /> Download Pdf </Button>}
                      </Pdf> */}
                      {/* <button className="ms-4" variant="success">s */}
                        <PDFDownloadLink
                        // style={{ textDecoration: "none" ,color:"white", backgroundColor:"#14A44D" , border:"none" }}
                          document={<DocumentFormat data={proposal} />}
                          fileName={("Proposal.pdf")}
                          className="btn btn-success ms-4"
                        >
                          {({ blob, url, loading, error }) =>
                          (
                            loading ? 'Loading document...' : <> <FaFilePdf /> Download PDF</> 
                          )
                          }
                        </PDFDownloadLink>
                      {/* </button>s */}
                      <Button variant="danger" style={{ marginLeft: "20px" }} onClick={() => { handleProposalDelete(proposal._id) }}>
                        Delete Proposal
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </>
          ))
        }
        {
          loader && <div className="d-flex justify-content-center align-items-center h-100"> <div className="spinner-border" role="status"> <span className="visually-hidden">Loading...</span> </div> </div>
        }
        <Row>
          <Col>
            <Modal show={showModal} onHide={handleModalClose} size="lg" aria-labelledby="contained-modal-title-vcenter" centered >
              <Modal.Header className="modal-header-custom" closeButton>
                <Modal.Title>
                  <h2>{selectedProposal?.jobTitle || "---"}</h2>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Container>
                  <Row>
                    <Col className="font-text-bold text-uppercase mb-2" sm={12} md={12} lg={12} xl={12}>Tech Stack:</Col>
                  </Row>
                  <Row>
                    <Col className="mb-4 px-4" sm={12} md={12} lg={12} xl={12}>{selectedProposal?.techstack || "---"}</Col>
                  </Row>
                  <Row>
                    <Col className="font-text-bold text-uppercase mb-2" sm={12} md={12} lg={12} xl={12}>Description:</Col>
                  </Row>
                  <Row>
                    <Col className="mb-4 px-4" sm={12} md={12} lg={12} xl={12}>{selectedProposal?.jobDescription || "---"}</Col>
                  </Row>
                  <Row>
                    <Col className="font-text-bold text-uppercase mb-2" sm={12} md={12} lg={12} xl={12}>Proposal:</Col>
                  </Row>
                  <Row>
                    <Col dangerouslySetInnerHTML={{ __html: `<p>${selectedProposal?.proposal || "---"}</p>` }} />
                  </Row>
                  <Row>
                    <Col className="text-uppercase font-text-bold mb-2">
                      QUESTION & ANSWER:
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} md={12} lg={12} xl={12} className="px-4">
                      <Accordion defaultActiveKey="0">
                        {
                          selectedProposal?.answers?.map((item, index) => (
                            <Accordion.Item eventKey={index}>
                              <Accordion.Header className="question">{item?.question.replace(/\?/g, ' ? ')}</Accordion.Header>
                              <Accordion.Body>
                                {item?.answer}
                              </Accordion.Body>
                            </Accordion.Item>
                          ))
                        }
                      </Accordion>
                    </Col>
                  </Row>
                </Container>
              </Modal.Body>
            </Modal>
          </Col>
        </Row>
      </Container>

    </>

  );
};

export default ProposalList;
